// Import necessary modules and components from external libraries and local files.
import React, { useContext } from "react";
import { Route, Routes } from "react-router-dom";
import "./App.css"; // Import CSS styles for the application.
import Home from "./components/iam/Home/Home"; // Import the Home component.
import Login from "./components/iam/Login/Login"; // Import the Login component.
import Signup from "./components/iam/Register/Signup"; // Import the Signup component.

import UserGroup from "./components/iam/UserGroups/UserGroup"; // Import the UserGroup component.
import UserProfile from "./components/iam/Users/UserProfile"; // Import the UserProfile component.
import ViewUsers from "./components/iam/Users/ViewUsers"; // Import the ViewUsers component.

import { AuthContext } from "./context/AuthContext"; // Import the authentication context.
import AnonymousRoutes from "./utils/AnonymousRoutes"; // Import utility for anonymous routes.
import PrivateRoutes from "./utils/PrivateRoutes"; // Import utility for private routes.

import ForgotPasswordInputEmail from "./components/iam/Login/ForgotPassword/ForgotPasswordInputEmail"; // Import the ForgotPasswordInputEmail component.
import PPEForm from "./components/iam/ppe/ppeForm";

import Patient from "./components/iam/patient/patient";
import Support from "./components/iam/Login/Support";

import DashboardPPE from "./components/iam/ppe/ppeDashboard";

import HHDashboard from "./components/iam/HandHygiene/HHDashboard";
import HandHygieneRecords from "./components/iam/HandHygiene/HandHygieneRecords";
import HandHygieneForm from "./components/iam/HandHygiene/HandHygieneForm";
import Loading from "./components/iam/Shared/Loading";
import NarcoticsDashboard from "./components/iam/Narcotics/NarcoticsDashboard";
import NarcoticsForm from "./components/iam/Narcotics/NarcoticsForm";
import PatientCareDashboard from "./components/iam/PatientCare/PatientCareDashboard";
import PatientCareForm from "./components/iam/PatientCare/PatientCareForm";
import DiningDashboard from "./components/iam/DiningAudit/DiningAuditDashboard";
import DiningForm from "./components/iam/DiningAudit/DiningForm";

// Define the main routing component called "MainRoutes."
function MainRoutes() {
  const {
    isAuthenticated,
    errorAccessDenied,
    setErrorAccessDenied,
    userGroup,
  } = useContext(AuthContext);

  // Return the JSX content for rendering the routes.
  if (isAuthenticated) {
    if (!userGroup) {
      return (
        <div>
          <Loading />
        </div>
      );
    }
  }

  return (
    <>
      <Routes>
        {/* Define private routes using the "PrivateRoutes" component */}
        <Route
          element={
            <PrivateRoutes
              isAuthenticated={isAuthenticated}
              userGroup={userGroup}
              error={errorAccessDenied}
              setError={setErrorAccessDenied}
            />
          }
        >
          {userGroup?.name === "patient" ? (
            <>
              <Route element={<Patient />} path="/" exact />
            </>
          ) : (
            <>
              {!userGroup?.handHygieneModule?.handHygieneForm?.list ? (
                <>
                  <Route element={<HandHygieneForm />} path="/" exact />
                </>
              ) : (
                <>
                  <Route element={<HHDashboard />} path="/" />
                </>
              )}
            </>
          )}
          {/* Define individual routes for various pages */}
          <Route element={<Home />} path="/profile" exact />
          <Route element={<UserProfile />} path="/users/:id" />
          <Route element={<UserGroup />} path="/userGroups" />
          <Route element={<Patient />} path="/patient" />
          {/* 
          <Route
            element={<HandHygieneObservation />}
            path="/HandHygieneObservation"
          /> */}
          {/* <Route element={<ViewForm />} path="/ViewForm" /> */}

          <Route element={<HandHygieneRecords />} path="/HandHygieneRecords" />

          {!userGroup?.handHygieneModule?.handHygieneForm?.list ? (
            <Route element={<HandHygieneForm />} path="/HandHygiene" />
          ) : (
            <Route element={<HHDashboard />} path="/HandHygiene" />
          )}

          {userGroup?.ppeModule?.ppeForm?.list ? (
            <Route element={<DashboardPPE />} path="/ppe" />
          ) : (
            <Route element={<PPEForm />} path="/ppe" />
          )}

          {userGroup?.narcoticsModule?.narcoticsForm?.list ? (
            <Route element={<NarcoticsDashboard />} path="/narcotics" />
          ) : (
            <Route element={<NarcoticsForm />} path="/narcotics" />
          )}

          {userGroup?.patientCareModule?.patientCareForm?.list ? (
            <Route element={<PatientCareDashboard />} path="/patient-care" />
          ) : (
            <Route element={<PatientCareForm />} path="/patient-care" />
          )}

          {userGroup?.diningModule?.diningForm?.list ? (
            <Route element={<DiningDashboard />} path="/dining" />
          ) : (
            <Route element={<DiningForm />} path="/dining" />
          )}

          <Route element={<ViewUsers />} path="/users" />
        </Route>

        {/* Define anonymous routes for signup and login */}
        <Route element={<AnonymousRoutes isAuthenticated={isAuthenticated} />}>
          <Route element={<Signup />} path="/auth/signup" />
        </Route>
        <Route element={<AnonymousRoutes isAuthenticated={isAuthenticated} />}>
          <Route element={<Login />} path="/auth/login" exact />
          <Route element={<Support />} path="/contact" exact />
          <Route
            element={<ForgotPasswordInputEmail />}
            path="/auth/forgotPassword"
            exact
          />
        </Route>

        {/* Define a route for handling 404 (Page Not Found) */}
        <Route path="*" element={<PageNotFound />} />
      </Routes>
    </>
  );
}
// Export the "MainRoutes" component as the default export of this module.
export default MainRoutes;
// Define a simple component for rendering a 404 Page Not Found message.
function PageNotFound() {
  return (
    <div>
      <h2>404 Page not found</h2>
    </div>
  );
}
